// @flow strict
import {useEffect} from 'react'

type Props = $ReadOnly<{
  title: string,
}>

function PageTitle({title}: Props): null {
  useEffect(() => {
    document.title = title
  }, [title])

  return null
}

export default PageTitle
